

/* tslint:disable */



export enum LinkAnchor {
    Top = 0,
    Bottom = 1,
    Left = 2,
    Right = 3,

}


